import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/");
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="pt-32 md:pt-40 pb-24 min-h-[80vh]">
      <div className="max-w-md mx-auto px-6">
        <div className="overline mb-5">{t("auth.login_overline")}</div>
        <h1 className="font-serif text-5xl text-[#F5F5F0] mb-12 leading-[0.95]">{t("auth.login_title")}</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="lux-label">{t("auth.email")}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="lux-input" required data-testid="login-email" />
          </div>
          <div>
            <label className="lux-label">{t("auth.password")}</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="lux-input" required data-testid="login-password" />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-400 border border-red-900/60 bg-red-900/10 p-3">{error}</div>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full disabled:opacity-60">
            {loading ? t("auth.logging_in") : t("auth.login_cta")}
          </button>
        </form>
        <p className="text-sm text-[#A3A39D] mt-10">
          {t("auth.no_account")}{" "}
          <Link to="/register" data-testid="to-register-link" className="text-[#D4AF37] hover:text-[#F0C050]">{t("auth.create_account")}</Link>
        </p>
      </div>
    </div>
  );
}
